import RelatedPosts from './RelatedPosts'

export default RelatedPosts
